import axios from "axios";
import { Profile } from "../models/Profile.model";

const SERVER = process.env.REACT_APP_SERVER_BASE;

export const getProfileById = async (userId: string): Promise<Profile> => {
  const response = await axios.get<Profile>(
    `${SERVER}/profile/${encodeURIComponent(userId)}`,
  );

  if (response.status === 404) throw new Error("User not found");
  else return response.data;
};

export const updateProfile = async (payload: Profile): Promise<void> => {
  await axios.post(`${SERVER}/profile`, payload);

  return;
};
